import { defineComponent as _defineComponent } from 'vue'
import type { BlobHandlerDialogProvider } from './blob-handler-dialog';
import { useGlobalBlobHandlerDialog } from './blob-handler-dialog';
import DownloadBlob from './download-blob.vue';
import ViewBlobDialog from './view-blob-dialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'blob-handler-dialog',
  props: {
    provider: null
  },
  setup(__props: any) {

const props = __props as {
    provider?: BlobHandlerDialogProvider;
}


const _provider = props.provider || useGlobalBlobHandlerDialog();


return { __sfc: true,props, _provider, DownloadBlob, ViewBlobDialog }
}

})